import { createFileRoute } from "@tanstack/react-router";

import { loadMe } from "../features/auth/session";
import { PublicLayout } from "../features/marketing/PublicLayout";
import { LegalPage } from "../features/marketing/legal/LegalPage";
import { PRIVACY } from "../features/marketing/legal/privacy";

export const Route = createFileRoute("/privacy")({
  staticData: { publicShell: true },
  loader: ({ context }) => loadMe(context.queryClient),
  component: PrivacyPage,
});

function PrivacyPage() {
  const me = Route.useLoaderData();
  return (
    <PublicLayout signedIn={me !== null}>
      <LegalPage documents={PRIVACY} />
    </PublicLayout>
  );
}
